export const
    HOME = "home",
    PENDING_TASKS = "mypendingtask",
    PENDING_APPROVALS = "mypendingapprovals",
    PENDING_SUBMISSIONS= "mypendingsubmissions",
    TRAININGS = "mytrainings",
    UPCOMING_TRAININGS = "upcomingtrainings",
    TRAINING_CALENDER = "trainingcalender",
    COURSE_CATALOUGE = "coursecatalouge",
    COURSE_MASTER = "coursemaster",
    VENDORS = "vendors",
    COURSE_QUESTIONNAIRE = "coursequestionnaire",
    CATEGORY1 = "category1",
    CATEGORY2 = "category2",
    SKILLS = "skills",
    JOBS = "jobs",
    LETTER_UNDERTAKING = "letterofundertaking",
    COMMITTEE_ROLES = "committee_roles",
    SKILL_MATRIX = "skillmatrix",
    SKILL_OVERVIEW = "skilloverview",
    TEAM_SKILL_CHART = "teamskillchart",
    TEAM_TRAININGS = "teamstrainings",
    PTE_1 = "pte",
    /* PTE_2 = "pte2",
    PTE_3 = "pte3", */
    LEVEL = "level",
    GRADING = "competencygrading",
    PROFICIENCY = "proficiency",
    MAIN_ROLES = "mainroles",
    MY_TEAM = "/myteam",
    REQUEST_STATUS = "requeststatus",
    TRAINING_RECORDS = "trainingrecord",
    SKILLPROFICIENCYDURATION="skillproficiencyduration"

    






